import './HomePage.css'

function HomePage() {
  const features = [
    {
      icon: '📝',
      title: '买前计划',
      description: '记录买入逻辑、预期收益、止损位、持有周期和卖出条件。让每一笔交易都有据可循，避免冲动决策。',
      tags: ['免费'],
      isVip: false,
    },
    {
      icon: '📊',
      title: '持仓跟踪',
      description: '记录加仓、减仓、改计划和情绪变化。追踪你是否在按计划执行，还是在悄悄偏离初衷。',
      tags: ['免费'],
      isVip: false,
    },
    {
      icon: '🔍',
      title: '卖出复盘',
      description: '填写实际卖出结果、是否按计划执行、最大错误和下次改进方向。完成交易闭环。',
      tags: ['免费'],
      isVip: false,
    },
    {
      icon: '🤖',
      title: 'AI 深度复盘',
      description: '不只是盈亏数字，AI 帮你拆解原计划 vs 实际执行的偏差链路，找到这笔交易真正的问题所在。',
      tags: ['VIP'],
      isVip: true,
    },
    {
      icon: '🔗',
      title: '相似交易识别',
      description: '查看这笔交易与过去哪些案例最相似，这类交易历史上是否奏效，最常见失败原因是什么。',
      tags: ['VIP'],
      isVip: true,
    },
    {
      icon: '👤',
      title: '交易行为画像',
      description: '看清你最赚钱的逻辑类型、最常见的错误、最容易受影响的时刻，以及真实的风险承受力。',
      tags: ['VIP'],
      isVip: true,
    },
  ]

  const steps = [
    {
      number: '1',
      title: '买前做计划',
      description: '买入前记录逻辑、预期收益、止损位和卖出条件。AI 预检查帮你发现计划漏洞。',
    },
    {
      number: '2',
      title: '持仓记变化',
      description: '加仓、减仓或改计划时记录原因和情绪状态。追踪偏离轨迹。',
    },
    {
      number: '3',
      title: '卖出写复盘',
      description: '记录实际结果、是否按计划执行、最大错误。完成基础复盘。',
    },
    {
      number: '4',
      title: '长期看画像',
      description: '积累足够数据后，查看自己的行为模式和重复错误，针对性改进。',
    },
  ]

  const freeFeatures = [
    '新建交易计划',
    '记录持仓变化',
    '基础卖出复盘',
    '最近 20 笔交易记录',
    '基础统计数据',
    '轻量 AI 提示',
  ]

  const vipFeatures = [
    '新建交易计划',
    '记录持仓变化',
    '基础卖出复盘',
    '无限历史记录',
    '完整统计数据',
    'AI 深度复盘报告',
    '历史相似交易识别',
    '完整交易行为画像',
    '周报 / 月报',
    '高级筛选与标签分析',
    '导出复盘报告',
  ]

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span>●</span> A股散户专属交易日志工具
          </div>
          <h1>不只是记录交易，<br />而是看清你为什么总在同一个地方犯错。</h1>
          <p className="hero-subtitle">
            TradeMirror 交易镜帮你建立「买前计划 → 持仓跟踪 → 卖出复盘」的完整闭环。
            用 AI 深度分析识别你的重复错误模式，让每笔交易都成为可回看的案例。
          </p>
          <div className="hero-cta">
            <a href="#pricing" className="btn-primary">开始使用</a>
            <a href="#features" className="btn-secondary">了解更多</a>
          </div>
          <p className="hero-note">免费版可记录 20 笔完整交易，足够你先感受价值。</p>
        </div>
      </section>

      {/* Features Section */}
      <section className="features" id="features">
        <div className="container">
          <div className="section-header">
            <p className="section-label">核心功能</p>
            <h2>记录免费，洞察收费</h2>
            <p className="section-subtitle">
              免费版让你建立记录习惯，VIP 才提供真正有价值的复盘洞察。
            </p>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className={`feature-icon ${feature.isVip ? 'vip' : ''}`}>{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <div className="feature-tags">
                  {feature.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className={`tag ${feature.isVip ? 'vip' : ''}`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="how-it-works" id="how-it-works">
        <div className="container">
          <div className="section-header">
            <p className="section-label">使用流程</p>
            <h2>先建立习惯，后看见模式</h2>
            <p className="section-subtitle">
              四步闭环，让你的交易记录变成可复用的经验资产。
            </p>
          </div>
          <div className="steps">
            {steps.map((step, index) => (
              <div key={index} className="step">
                <div className="step-number">{step.number}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="quote-section">
        <div className="container">
          <p className="quote">
            "看见偏差，<span className="quote-accent">比追逐机会更重要。</span><br />
            先识别旧错误，再谈新机会。"
          </p>
          <p className="quote-author">—— TradeMirror 产品理念</p>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing" id="pricing">
        <div className="container">
          <div className="section-header">
            <p className="section-label">定价</p>
            <h2>免费先建立习惯，VIP 帮你看见模式</h2>
            <p className="section-subtitle">
              不是为了看更多功能，而是为了更早发现重复犯错。
            </p>
          </div>
          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>免费版</h3>
              <p className="pricing-desc">适合先建立习惯，感受产品价值</p>
              <ul className="pricing-features">
                {freeFeatures.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
                {vipFeatures.slice(freeFeatures.length - 3).map((feature, index) => (
                  <li key={`disabled-${index}`} className="disabled">{feature}</li>
                ))}
              </ul>
              <button className="btn-secondary" style={{ width: '100%' }}>
                免费开始
              </button>
            </div>
            <div className="pricing-card featured">
              <div className="featured-badge">推荐</div>
              <h3>VIP 版</h3>
              <div className="price">
                ¥38<span>/月</span>
              </div>
              <p className="pricing-desc">适合真正要拿它来纠偏的人</p>
              <ul className="pricing-features">
                {vipFeatures.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <button className="btn-primary" style={{ width: '100%' }}>
                解锁深度复盘
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default HomePage
